import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const CalendarSolid: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.14272 1.71415C5.14272 1.08296 4.63104 0.571289 3.99986 0.571289C3.36868 0.571289 2.857 1.08296 2.857 1.71415V2.857H2.28557C1.3388 2.857 0.571289 3.62451 0.571289 4.57129V13.7141C0.571289 14.6609 1.3388 15.4284 2.28557 15.4284H13.7141C14.6609 15.4284 15.4284 14.6609 15.4284 13.7141V4.57129C15.4284 3.62451 14.6609 2.857 13.7141 2.857H13.1427V1.71415C13.1427 1.08296 12.6311 0.571289 11.9999 0.571289C11.3687 0.571289 10.857 1.08296 10.857 1.71415V2.857H5.14272V1.71415ZM3.857 7.99986C3.857 7.60537 4.1768 7.28557 4.57129 7.28557H11.4284C11.8229 7.28557 12.1427 7.60537 12.1427 7.99986C12.1427 8.39435 11.8229 8.71415 11.4284 8.71415H4.57129C4.1768 8.71415 3.857 8.39435 3.857 7.99986ZM3.857 11.4284C3.857 11.0339 4.1768 10.7141 4.57129 10.7141H7.99986C8.39435 10.7141 8.71415 11.0339 8.71415 11.4284C8.71415 11.8229 8.39435 12.1427 7.99986 12.1427H4.57129C4.1768 12.1427 3.857 11.8229 3.857 11.4284Z"
      fill="currentColor"
    />
  </svg>
);
